import React, { Component } from 'react';
import SocialList from '../components/social-list.js';

import NME from '../assets/logos/nme.svg';

class Landing extends Component {
    render() {
        const image = {
            width: '300px',
        }

        return (
            <div className="section" data-tooltip="NME">
                <SocialList color="#283991"/>
                <div className="container-fluid">
                    <div className="row">
                        <div className="mx-auto col-xs-8 col-md-6">
                            <img className="img-fluid" src={NME} alt="logo" style={image}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default Landing;



// WEBPACK FOOTER //
// ./src/pages/landing.js